<template>
  <div class="view pa24" v-loading="loading">
    <div class="toolbar">
      <div class="title">短视频内容效果</div>
      <el-button type="primary" plain @click="load">刷新</el-button>
    </div>
    <el-row :gutter="16" class="mb16">
      <el-col :span="6" v-for="item in summaryCards" :key="item.label">
        <div class="stat-card">
          <div class="label">{{ item.label }}</div>
          <div class="value">{{ item.value }}</div>
        </div>
      </el-col>
    </el-row>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="videoId" label="ID" width="80" align="center" />
        <el-table-column prop="title" label="标题" align="center" show-overflow-tooltip />
        <el-table-column prop="userName" label="上传者" width="100" align="center" />
        <el-table-column prop="playVolume" label="播放量" width="90" align="center" />
        <el-table-column prop="guestsNum" label="获客" width="80" align="center">
          <template slot-scope="scope">
            <span style="color:#fd634e">{{ scope.row.guestsNum || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="likesNum" label="点赞" width="70" align="center" />
        <el-table-column prop="commentNum" label="评论" width="70" align="center" />
        <el-table-column prop="forwardNum" label="转发" width="70" align="center" />
        <el-table-column label="互动率" width="90" align="center">
          <template slot-scope="scope">
            {{ interactRate(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.state == 0 ? '已下架' : '已上架' }}
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from '@/components/common/commonTable'
import { queryPage } from '@/api/videoManage'

export default {
  name: 'VideoAnalytics',
  components: { commonTable },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      summary: {
        play: 0,
        guests: 0,
        likes: 0,
        comments: 0
      }
    }
  },
  computed: {
    summaryCards() {
      return [
        { label: '总播放量', value: this.summary.play },
        { label: '总获客', value: this.summary.guests },
        { label: '总点赞', value: this.summary.likes },
        { label: '总评论', value: this.summary.comments }
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    interactRate(row) {
      const play = Number(row.playVolume) || 0
      if (!play) return '0%'
      const interact =
        (Number(row.likesNum) || 0) +
        (Number(row.commentNum) || 0) +
        (Number(row.forwardNum) || 0)
      return ((interact * 100) / play).toFixed(1) + '%'
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.load()
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.load()
    },
    async load() {
      this.loading = true
      try {
        const res = await queryPage({
          pageNum: this.currentPage,
          pageSize: this.pageSize
        })
        const data = (res && res.data) || {}
        this.tableData = data.list || data.records || []
        this.total = data.total || 0
        this.summary = {
          play: this.tableData.reduce((s, i) => s + (Number(i.playVolume) || 0), 0),
          guests: this.tableData.reduce((s, i) => s + (Number(i.guestsNum) || 0), 0),
          likes: this.tableData.reduce((s, i) => s + (Number(i.likesNum) || 0), 0),
          comments: this.tableData.reduce((s, i) => s + (Number(i.commentNum) || 0), 0)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  .title {
    font-size: 18px;
    font-weight: 600;
  }
}
.mb16 { margin-bottom: 16px; }
.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 8px;
  .label { color: #8a8f93; font-size: 13px; }
  .value { color: #51cbcd; font-size: 26px; font-weight: 700; margin-top: 8px; }
}
</style>
